import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=c87c75f8&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=c87c75f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c75f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c87c75f8')) {
      api.createRecord('c87c75f8', component.options)
    } else {
      api.reload('c87c75f8', component.options)
    }
    module.hot.accept("./reset-password.vue?vue&type=template&id=c87c75f8&scoped=true&", function () {
      api.rerender('c87c75f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/reset-password.vue"
export default component.exports